import apiClient from './apiClient';

export interface FP510 {
  fp510_01: string;  // 客戶代號
  fp510_10: string;  // 客戶名稱
  fp510_11: string;  // 收貨人
  fp510_12: string;  // 電話
  fp510_13: string;  // 送貨地點
  fp510_91: string;
  fp510_92: string | null;
  fp510_93: string;
}

export interface CreateRequest {
  fp510_01: string; fp510_10: string; fp510_11: string;
  fp510_12: string; fp510_13: string;
}

export interface UpdateRequest {
  fp510_10: string; fp510_11: string;
  fp510_12: string; fp510_13: string;
}

export interface ListResponse { data: FP510[]; total: number; page: number; size: number; }

export const packCustomerApi = {
  async list(page = 1, size = 500, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/pack-customer', { params })).data;
  },
  async get(code: string): Promise<FP510> {
    return (await apiClient.get(`/api/pack-customer/${encodeURIComponent(code)}`)).data;
  },
  async create(data: CreateRequest): Promise<FP510> {
    return (await apiClient.post('/api/pack-customer', data)).data;
  },
  async update(code: string, data: UpdateRequest): Promise<FP510> {
    return (await apiClient.put(`/api/pack-customer/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/pack-customer/${encodeURIComponent(code)}`);
  },
};
